// extracted by mini-css-extract-plugin
module.exports = {"container":"CollapsibleTitleWithCaret--container--1GobF"};